__webpack_require__.p = "/OCTGN-MtG-Deck-Converter/";